// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3ef387e1","952":"c97bbe21"}[chunkId] + ".chunk.js";
};